import { baseApi } from '@ibk/shared-config';
export const bankApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getBanks: builder.query({
            query: () => ({
                url: '/v1/bank',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
    }),
});
export const { useLazyGetBanksQuery } = bankApi;
